import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home/Home.vue'
import ProfileRoute from '@/views/Profile/router'
import i18n  from "@/plugins/i18n";
import ArtizePage from '@/components/Domain/Artzie/ArtizePage.vue'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: '/',
  scrollBehavior(to, from, savedPosition) {
    // If route change while dragging artwork inside taikoTest wall
    if (to.name === 'artist.artwork.test' && (to.query.size || to.query.left || to.query.top)) {
      return
    }

    console.log('ScrollBehavior', 'Move top')
    // This will simply make the page scroll to top for all route navigations.
    // window.scrollTo({ top: 0, behavior: 'smooth' });
    // return { x: 0, y: 0 };
    return new Promise((resolve, reject) => {
      setTimeout(() => resolve({ x: 0, y: 0 }), 100)
    })
  },
//  parseQuery (query) {
//    return qs.parse(query)
//  },
//  stringifyQuery (query) {
//    const result = qs.stringify(query, { allowDots: true })
//
//    return result ? ('?' + result) : ''
//  },
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      meta: { title: i18n.t('COMMON.HOME_PAGE_TITLE') }
    },
    {
      path: '/artzie',
      name: 'home.artzie',
      component: Home,
      meta: { title: i18n.t('COMMON.HOME_PAGE_TITLE'), openArtzie: true }
    },
    {
      name: 'signup',
      path: '/signup',
      // route level code-splitting
      // this generates a separate chunk (signup.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "signup" */ './views/Signup/Signup.vue'),
      // component: SearchPage
      meta: { title: `${i18n.t('COMMON.SIGNUP')} | Taiko` }
    },

    {
      path: '/artists',
      name: 'artists.index',
      component: () => import(/* webpackChunkName: "artists.index" */ './views/Artists/Artists.vue'),
      meta: { title: `${i18n.tc('COMMON.ARTIST', 2)} | Taiko` }
    },

    {
      path: '/search',
      name: 'search',
      alias: [
        '/painting',
        '/sculpture',
        '/photography',
        '/graphic-print'
      ],
      component: () => import(/* webpackChunkName: "search.index" */ '@/views/Search/SearchPage.vue'),
      meta: { title: `${i18n.t('COMMON.SEARCH')} | Taiko` }
    },

    // Cart route
    {
      path: '/cart',
      name: 'cart',
      component: () => import(/* webpackChunkName: "cart" */ './views/Cart/Cart.vue'),
      meta: { title: `${i18n.t('COMMON.SHOPPING_CART')} | Taiko` }
    },

    // News route
    {
      path: '/news',
      name: 'news',
      component: () => import(/* webpackChunkName: "news" */ './views/News/News.vue'),
      meta: { title: `${i18n.t('MENU.NEWS')} | Taiko` }
    },

    // Post route
    {
      path: '/news/:newsSlug',
      name: 'news.single',
      component: () => import(/* webpackChunkName: "news.single" */ './views/News/Single.vue'),
      props: true
    },

    // Galleries route
    {
      path: '/galleries',
      name: 'galleries',
      component: () => import(/* webpackChunkName: "galleries" */ './views/Galleries/Galleries.vue'),
      meta: { title: `${i18n.tc('MENU.GALLERY', 2)} | Taiko` }
    },

    // Galleries single route
    {
      path: '/galleries/:gallerySlug',
      name: 'galleries.single',
      component: () => import(/* webpackChunkName: "galleries.single" */ './views/Galleries/Single.vue'),
      props: true
    },

    // Checkout route
    {
      path: '/checkout',
      name: 'checkout',
      component: () => import(/* webpackChunkName: "checkout" */ './views/Checkout/Checkout.vue'),
      meta: { title: `${i18n.t('CART.CHECKOUT')} | Taiko` }
    },

    // Giftcard route
    {
      path: '/giftcard',
      name: 'giftcard',
      component: () => import(/* webpackChunkName: "giftcard" */ './views/GiftCard/GiftCard.vue'),
      meta: { title: `${i18n.t('MENU.GIFT_CARDS')} | Taiko` }
    },
    // Giftcard checkout route
    {
      path: '/giftcard/checkout',
      name: 'giftcard.checkout',
      component: () => import(/* webpackChunkName: "giftcard.checkout" */ './views/GiftCard/Checkout.vue'),
      meta: { title: `${i18n.t('CART.CHECKOUT')} | Taiko` }
    },

    // Newsletter route
    {
      path: '/newsletter',
      name: 'newsletter',
      component: () => import(/* webpackChunkName: "newsletter" */ './views/NewsLetter/NewsLetter.vue'),
      meta: { title: `${i18n.t('MENU.NEWSLETTER')} | Taiko` }
    },


//     About route
    {
      path: '/about',
      name: 'about',
      component: () => import(/* webpackChunkName: "newsletter" */ './views/About/About.vue'),
      meta: { title: `${i18n.t('MENU.ABOUT_TAIKO')} | Taiko` }
    },

    // Cancellation notice route
    {
      path: '/cancellation',
      name: 'cancellation',
      component: () => import(/* webpackChunkName: "cancellation" */ './views/CancellationNotice/CancellationNotice.vue'),
      meta: { title: `${i18n.t('MENU.CANCELLATION_NOTICE')} | Taiko` }
    },

    // insert profile routing
    ProfileRoute,

    // Subpages
    {
      path: '/companies',
      name: 'pages',
      alias: [
//        '/about',
        '/abc',
        '/buyersfaq',
        '/whybuy',
        '/payment',
        '/delivery',
        '/returns',
        '/giftcardinfo',
        '/artistguide',
        '/artistfaq',
        '/company',
        '/supportartist',
        '/media',
        '/customer-feedback',
        '/termsconditions',
        '/about-this-site',
        '/contact',
        '/commission',
        '/aland',
        '/taikos-catalogues',
      ],
      component: () => import(/* webpackChunkName: "pages" */ './views/Pages/Pages.vue')
    },

    // Single artist route eg. taiko.fi/padam-shrestha
    {
      path: '/:artistSlug',
      name: 'artist.single',
      component: () => import(/* webpackChunkName: "artist.single" */ './views/Artists/Single.vue'),
      props: true,
    },

    // Single artwork routes
    {
      path: '/:artistSlug/:artworkId',
      component: () => import(/* webpackChunkName: "artist.artwork.index" */ './views/Artists/Artwork/ArtistArtworkViewPage.vue'),
      props: true,
      children: [
        {
          path: '',
          name: 'artist.artwork',
          component: () => import(/* webpackChunkName: "artist.artwork" */ './views/Artists/Artwork/ImageView.vue'),
        },
        {
          path: 'test/:wallId',
          name: 'artist.artwork.test',
          component: () => import(/* webpackChunkName: "artist.artwork.test" */ './views/Artists/Artwork/Test/TaikoTest.vue'),
          props: true
        }
      ]
    }
  ],
})

router.afterEach((to) => {
  if (window['dataLayer']) {
    window['dataLayer'].push({ event: 'pageview' })
  }


  const title = to.meta ? to.meta.title : '-'
  if (title) document.title = title

})

export default router
